// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__1fJXt","calendarButtons":"ClockData_calendarButtons__bVBKb"};